import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="bg-bone py-24 md:py-36 px-6 md:px-10" data-id="element-12">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1
      }} className="lg:col-span-5 aspect-[3/4] overflow-hidden" data-id="element-14">
          <img src="https://images.unsplash.com/photo-1518684079-3c830dcef090?w=1000&q=80&auto=format&fit=crop" alt="Mediterranean villa light" className="w-full h-full object-cover" data-id="element-15" />
        </motion.div>

        <div className="lg:col-span-7 lg:pl-6" data-id="element-16">
          <motion.h2 initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9
        }} className="font-serif-display text-3xl md:text-5xl leading-[1.1] text-ink" data-id="element-17">
            This isn't a retreat. <br data-id="element-18" />
            <span className="italic" data-id="element-19">It's not a vacation either.</span>
          </motion.h2>

          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.3
        }} style={{
          transformOrigin: 'left'
        }} className="mt-8 w-10 h-px bg-ink/40" data-id="element-20" />

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9,
          delay: 0.4
        }} className="mt-10 space-y-5 text-ink-soft text-[15px] leading-[1.85] max-w-xl" data-id="element-21">
            <p data-id="element-22">It's a shared home base, in a place you'll actually feel.</p>
            <p data-id="element-23">
              You'll spend a week living somewhere new — with a small group of
              women who all decided to show up for something different.
            </p>
            <p data-id="element-24">You'll share meals. Wander. Meet people passing through.</p>
            <p data-id="element-25">And somewhere in the middle of it, something quietly shifts.</p>
            <p className="font-serif-display italic text-ink text-xl md:text-2xl pt-4 leading-snug" data-id="element-26">
              It's the feeling of a solo trip… <br data-id="element-27" />
              without being alone.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}